export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jeśli anulujesz transakcję, zostanie ona zamknięta bez ukończenia operacji."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czy na pewno chcesz anulować transakcję?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak, anuluj"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie, pozostaw aktywną"])}
}